module.exports = __webpack_public_path__ + "files/097d02a902a6e52c00220b86de732f31.png";